function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgBookmarkLight = function SvgBookmarkLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M384,0H149.333c-41.237,0-74.667,33.429-74.667,74.667v426.667c0.001,4.316,2.603,8.207,6.592,9.856  c1.291,0.538,2.676,0.813,4.075,0.811c2.831,0.005,5.548-1.115,7.552-3.115l120.448-120.619  C260.48,434.795,325.44,499.2,332.416,507.136c3.261,4.906,9.882,6.24,14.788,2.979c1.775-1.18,3.155-2.864,3.964-4.835  c0.687-1.195,0.978-2.576,0.832-3.947v-448c0-17.673,14.327-32,32-32c5.891,0,10.667-4.776,10.667-10.667S389.891,0,384,0z",
    fill: "#ffc6d2",
    "data-original": "#2196f3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M394.667,0L394.667,0c23.564,0,42.667,19.103,42.667,42.667v32c0,5.891-4.776,10.667-10.667,10.667  H352l0,0V42.667C352,19.103,371.103,0,394.667,0z",
    fill: "#ffc6d2",
    "data-original": "#1976d2",
    className: ""
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarkLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark-light.c7dc7b59.svg";
export { ForwardRef as ReactComponent };